import { z } from "zod";
import { ChoiceOptionsSchema, defineControl, placeholderFieldSchema, } from "./field.js";
// The placeholder is what the list shows until a choice is made. Two options to
// start with, named and valued for their place, so the list has something to
// show before an administrator has named anything.
export const dropdownSingle = defineControl({
    key: "dropdownSingle",
    label: "Drop-down single selection",
    schema: placeholderFieldSchema("dropdownSingle").extend(ChoiceOptionsSchema.shape),
    answer: z.string(),
    isClearable: true,
    empty: {
        placeholder: "",
        required: false,
        options: [
            { label: "Option 1", value: "option-1" },
            { label: "Option 2", value: "option-2" },
        ],
    },
});
